"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveCircle = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../theme");
const RemoveCircle = ({ removeIcon }) => {
    const theme = theme_1.useSharedTheme();
    return (react_1.default.createElement(react_native_1.View, { style: [styles.removeCircle, { backgroundColor: theme.colors.negative }] }, removeIcon));
};
exports.RemoveCircle = RemoveCircle;
const styles = react_native_1.StyleSheet.create({
    removeCircle: {
        alignItems: 'center',
        borderRadius: 10,
        height: 20,
        justifyContent: 'center',
        width: 20,
    },
});
